<template>
  <div class="pdf-page">
    <slot />
  </div>
</template>

<style scoped>
@media screen {
  .pdf-page {
    margin: 1cm auto;
    padding: 1cm;
    max-width: 297mm;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
}
</style>
